import { render, staticRenderFns } from "./WardrobeDimensions.vue?vue&type=template&id=10d8e29c&"
import script from "./WardrobeDimensions.vue?vue&type=script&lang=js&"
export * from "./WardrobeDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports